/**
 * Back-in-stock notify form (PDP OOS).
 */
(function () {
  'use strict';
  if (window.__d1BackInStockScriptLoaded) return;
  window.__d1BackInStockScriptLoaded = true;

  var TURNSTILE_SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
  var turnstileLoadPromise = null;

  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve();
    if (turnstileLoadPromise) return turnstileLoadPromise;
    turnstileLoadPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + TURNSTILE_SCRIPT_SRC + '"]');
      if (existing) {
        existing.addEventListener('load', function () {
          if (window.turnstile) resolve();
          else reject(new Error('Turnstile failed to load'));
        });
        return;
      }
      var script = document.createElement('script');
      script.src = TURNSTILE_SCRIPT_SRC;
      script.async = true;
      script.onload = function () {
        if (window.turnstile) resolve();
        else reject(new Error('Turnstile failed to load'));
      };
      script.onerror = function () {
        reject(new Error('Turnstile failed to load'));
      };
      document.head.appendChild(script);
    });
    return turnstileLoadPromise;
  }

  function setStatus(root, message, tone) {
    var el = root.querySelector('[data-d1-bis-status]');
    if (!el) return;
    if (!message) {
      el.hidden = true;
      el.textContent = '';
      el.classList.remove('is-success', 'is-error');
      return;
    }
    el.hidden = false;
    el.textContent = message;
    el.classList.toggle('is-success', tone === 'success');
    el.classList.toggle('is-error', tone === 'error');
  }

  function syncVisibility(root) {
    var available = root.getAttribute('data-variant-available') === 'true';
    root.hidden = available;
  }

  function hideBrokenTurnstile(root) {
    var container = root.querySelector('[data-d1-bis-turnstile]');
    root.__d1BisTurnstileFailed = true;
    if (root.__d1BisTurnstileId != null && window.turnstile) {
      try {
        window.turnstile.remove(root.__d1BisTurnstileId);
      } catch (e) {}
      root.__d1BisTurnstileId = null;
    }
    if (container) {
      container.innerHTML = '';
      container.hidden = true;
      container.setAttribute('data-failed', 'true');
    }
    // Soft customer copy — never surface Cloudflare Troubleshoot UI.
    setStatus(
      root,
      'Notify is temporarily unavailable. Please use Contact options below, or try again later.',
      'error'
    );
  }

  function ensureTurnstile(root) {
    var siteKey = String(root.getAttribute('data-turnstile-site-key') || '').trim();
    var container = root.querySelector('[data-d1-bis-turnstile]');
    if (!siteKey || !container) return Promise.resolve();
    return loadTurnstile()
      .then(function () {
        if (root.__d1BisTurnstileId != null || root.__d1BisTurnstileFailed) return;
        root.__d1BisTurnstileId = window.turnstile.render(container, {
          sitekey: siteKey,
          theme: 'light',
          callback: function () {
            root.__d1BisTurnstileFailed = false;
            setStatus(root, '', null);
          },
          'error-callback': function () {
            hideBrokenTurnstile(root);
          },
          'timeout-callback': function () {
            hideBrokenTurnstile(root);
          },
        });
      })
      .catch(function () {
        hideBrokenTurnstile(root);
      });
  }

  function getTurnstileToken(root) {
    if (root.__d1BisTurnstileId == null || !window.turnstile) return '';
    try {
      return window.turnstile.getResponse(root.__d1BisTurnstileId) || '';
    } catch (e) {
      return '';
    }
  }

  function resetTurnstile(root) {
    if (root.__d1BisTurnstileId == null || !window.turnstile) return;
    try {
      window.turnstile.reset(root.__d1BisTurnstileId);
    } catch (e) {}
  }

  /** After a successful subscribe, hide the widget — don't reset (avoids Success → flash back). */
  function completeTurnstile(root) {
    var container = root.querySelector('[data-d1-bis-turnstile]');
    if (root.__d1BisTurnstileId != null && window.turnstile) {
      try {
        window.turnstile.remove(root.__d1BisTurnstileId);
      } catch (e) {}
      root.__d1BisTurnstileId = null;
    }
    if (container) {
      container.innerHTML = '';
      container.hidden = true;
    }
    root.__d1BisSubscribed = true;
  }

  function bindRoot(root) {
    if (root.__d1BisBound) return;
    root.__d1BisBound = true;
    syncVisibility(root);
    ensureTurnstile(root).catch(function () {
      hideBrokenTurnstile(root);
    });

    var form = root.querySelector('[data-d1-bis-form]');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      setStatus(root, '', null);

      if (root.__d1BisTurnstileFailed) {
        setStatus(
          root,
          'Notify is temporarily unavailable. Please use Contact options below, or try again later.',
          'error'
        );
        return;
      }

      var emailInput = root.querySelector('[data-d1-bis-email]');
      var submit = root.querySelector('[data-d1-bis-submit]');
      var email = emailInput ? String(emailInput.value || '').trim() : '';
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setStatus(root, 'Enter a valid email address.', 'error');
        return;
      }

      var siteKey = String(root.getAttribute('data-turnstile-site-key') || '').trim();
      var turnstileToken = getTurnstileToken(root);
      if (siteKey && !turnstileToken) {
        setStatus(root, 'Please complete the verification check.', 'error');
        return;
      }

      var honeypot = form.querySelector('input[name="honeypot"]');
      var apiUrl = String(root.getAttribute('data-api-url') || '').trim();
      if (!apiUrl) {
        setStatus(root, 'Notify is temporarily unavailable.', 'error');
        return;
      }

      if (submit) {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
      }

      var payload = {
        honeypot: honeypot ? honeypot.value : '',
        email: email,
        shopifyVariantId: String(root.getAttribute('data-variant-id') || ''),
        shopifyProductId: String(root.getAttribute('data-product-id') || ''),
        productHandle: String(root.getAttribute('data-product-handle') || ''),
        productTitle: String(root.getAttribute('data-product-title') || ''),
        variantTitle: String(root.getAttribute('data-variant-title') || '') || null,
        turnstileToken: turnstileToken,
      };

      fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'omit',
      })
        .then(function (res) {
          return res.json().then(function (body) {
            return { ok: res.ok, body: body };
          });
        })
        .then(function (result) {
          if (!result.ok || !result.body || result.body.success === false) {
            var msg =
              (result.body && (result.body.error || result.body.message)) ||
              'Could not save your request. Please try again.';
            if (typeof msg === 'object' && msg.message) msg = msg.message;
            setStatus(root, String(msg), 'error');
            // Token is single-use — reset only on failure so they can retry.
            resetTurnstile(root);
            if (submit) {
              submit.disabled = false;
              submit.removeAttribute('aria-busy');
            }
            return;
          }
          var already =
            result.body.data && result.body.data.alreadySubscribed
              ? 'You’re already on the list for this item.'
              : 'Thanks — we’ll email you when it’s back in stock.';
          setStatus(root, already, 'success');
          completeTurnstile(root);
          if (emailInput) {
            emailInput.value = '';
            emailInput.disabled = true;
          }
          if (submit) {
            submit.textContent = 'Subscribed';
            submit.disabled = true;
            submit.removeAttribute('aria-busy');
          }
        })
        .catch(function () {
          setStatus(root, 'Could not save your request. Please try again.', 'error');
          resetTurnstile(root);
          if (submit) {
            submit.disabled = false;
            submit.removeAttribute('aria-busy');
          }
        });
    });
  }

  function refreshFromVariant(variant) {
    if (!variant || !variant.id) return;
    document.querySelectorAll('[data-d1-bis]').forEach(function (root) {
      root.setAttribute('data-variant-id', String(variant.id));
      if (variant.title != null) root.setAttribute('data-variant-title', String(variant.title));
      root.setAttribute('data-variant-available', variant.available ? 'true' : 'false');
      syncVisibility(root);
      setStatus(root, '', null);
    });
  }

  function init() {
    document.querySelectorAll('[data-d1-bis]').forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('product-info:loaded', init);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (event && event.data && event.data.variant) {
        refreshFromVariant(event.data.variant);
      }
    });
  }

  document.addEventListener('change', function (event) {
    var form = event.target && event.target.closest && event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    // Dawn updates availability via section rendering; rely on pubsub primarily.
    void idInput;
  });
})();
